<div class="start-sesion-wrapper">
    <div class="go-back d-flex align-items-center" (click)="goBack()">
        <i class="fa-sharp fa-thin fa-arrow-left"></i>
        <span>Volver</span>
    </div>

    <div class="title-wrapper">
        <p class="title">Introduce la cantidad con la que comienzas la caja: </p>
    </div>
    <form class="login-form" [formGroup]="cashQuantity">
        <div class="row">
            <div class="col-12 d-flex align-items-center justify-content-center">
                <input class="cash-start-quantity w-25" placeholder="Cantidad" type="number"
                    formControlName="initial_balance"
                    [ngClass]="{'pristine-input': cashQuantity.controls['initial_balance'].pristine}">
                <p class="mb-0" style="margin-left: 0.5rem; font-weight: 500; font-size: 24px;">€</p>
            </div>
        </div>
    </form>
</div>